// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c82smr{font:var(--ds-font-body,normal 400 14px/20px ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._18m915vq{overflow-y:hidden}\n._1bto1l2s{text-overflow:ellipsis}\n._1e0c1txw{display:flex}\n._1reo15vq{overflow-x:hidden}\n._2hwxu2gc{margin-right:var(--ds-space-100,8px)}\n._4cvr1h6o{align-items:center}\n._k7zygrf3 ul{padding-left:0!important}\n._kqswh2mm{position:relative}\n._o5721q9c{white-space:nowrap}", ""]);
// Exports
module.exports = exports;
